import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { UserI } from '../shared/usuario.interface';
import { FileI } from '../shared/file.interface';
import { finalize, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private filePath: any;
  private downloadURL: string;
  userInfo: any;
  userDataPerfil: any;

  constructor(public afAuth: AngularFireAuth,
              private db: AngularFirestore,
              private storage: AngularFireStorage) {
  this.afAuth.authState.subscribe(user => {
    if (user) {
      this.userInfo = user;
      this.dataUser(this.userInfo.uid);
    }
  }); 
}

dataUser(idUser: string){
  let docRef = this.db.collection("usuarios").doc(idUser);
      docRef.get().subscribe((doc) => {
          if (doc.exists) {
            this.userDataPerfil = doc.data();
            this.userDataPerfil.uid = idUser;
              localStorage.setItem('dataUserSupedido', JSON.stringify(this.userDataPerfil));
          } else {
              console.log("No se encontraron datos!");
          }
      });
}

  login(email: string, password: string){
    try{
      return this.afAuth.signInWithEmailAndPassword(email, password);
    } catch (error) {
      console.log(error);
    }
  }

  register(email: string, password: string){
    try {
      return this.afAuth.createUserWithEmailAndPassword(email, password);
     } catch (error) {
      console.log(error);
    }
  }

  filterProd(usuario: UserI, image: FileI, nombreImg: string, idUser: string){
    this.uploadImage(usuario, image, nombreImg, idUser);
  }

  private uploadImage(usuario: UserI, image: FileI, nombreImg: string, idUser: string){
    this.filePath = `rut/${nombreImg}`;
    const fileRef = this.storage.ref(this.filePath);
    const task = this.storage.upload(this.filePath, image);
    task.snapshotChanges().pipe(
      finalize(() => {
        fileRef.getDownloadURL().subscribe( urlImage => {
          this.downloadURL = urlImage;
          this.agregarUsuarios(usuario, idUser);
        });
      })
    ).subscribe();
 }

 private agregarUsuarios(usuario: UserI, idUser: string){
    const prodObj = {
      nombre: usuario.nombre,
      cedula: usuario.cedula,
      email: usuario.email,
      estado: usuario.estado,
      fechaCreacion: usuario.fechaCreacion,
      tipo: usuario.tipo,
      telefono: usuario.telefono,
      rut: this.downloadURL,
      fileRef: this.filePath,
    };
    if (usuario.id) {
      return this.db.collection('usuarios').doc(usuario.id).update(prodObj);
    } else {
      return this.db.collection('usuarios').doc(idUser).set(prodObj);
    }
  }

  registrarComprador(user: any, idUser: string){
    return this.db.collection('usuarios').doc(idUser).set(user);
  }

  consultarTipoUsuario(idUser: string){
    return this.db.collection('usuarios').doc(idUser).valueChanges();
  }

  logout(){
    const usr: any = [];
    try {
      localStorage.setItem('dataUserSupedido', usr);
      this.afAuth.signOut();
    } catch (error) {
      console.log(error);
    }
  }

  actualizaNombreUsuario(idUser: string, newNombre: string){
    return this.db.collection('usuarios').doc(idUser).update({nombre: newNombre});
  }
  actualizaCedulaUsuario(idUser: string, newCedula: string){
    return this.db.collection('usuarios').doc(idUser).update({cedula: newCedula});
  }
  actualizaEmailUsuario(idUser: string, newEmail: string){
    return this.db.collection('usuarios').doc(idUser).update({email: newEmail});
  }
  actualizaTelefonoUsuario(idUser: string, newTel: string){
    return this.db.collection('usuarios').doc(idUser).update({telefono: newTel});
  }

  cargarDistribuidoresPendientes(){
    return this.db.collection('usuarios', ref => ref
                  .where('estado', '==', 'Pendiente'))
                  .snapshotChanges()
                  .pipe(
                    map(actions =>
                     actions.map(resp => {
                     const data = resp.payload.doc.data() as any;
                     const id = resp.payload.doc.id;
                     return {id, ...data};
                     }))
                    );
  }

  aceptarDistribuidor(idUser){
    return this.db.collection('usuarios').doc(idUser).update({estado: 'Activo'});
  }

  eliminarDistribuidor(idUser){
    return this.db.collection('usuarios').doc(idUser).delete();
  }

  desactivarDistribuidor(idUser){
    return this.db.collection('usuarios').doc(idUser).update({estado: 'Pendiente'});
  }

  listaClientes(){
    return this.db.collection('usuarios', ref => ref
                  .orderBy('fechaCreacion', 'desc'))
                  .snapshotChanges()
                  .pipe(
                    map(actions =>
                     actions.map(resp => {
                     const data = resp.payload.doc.data() as any;
                     const id = resp.payload.doc.id;
                     return {id, ...data};
                     }))
                    );
  }

  resetPassword(email: string){
    try {
      return this.afAuth.sendPasswordResetEmail(email);
    } catch (error) {
      console.log(error);
    }
  }
}
